//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CardPropertyIcon from './CardPropertyIcon.vue'
import AddressField from '../Field/AddressField.vue'

export default {
  name: 'CardPropertyAddress',
  components: {
    AddressField,
    CardPropertyIcon
  },
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  computed: {
    additionalObjectTypes: function () {
      const config = this.tabProp || {}
      if (config.componentProps && config.componentProps.additionalObjectTypes) {
        return config.componentProps.additionalObjectTypes
      } else {
        return []
      }
    }
  },
  created: function () {
    if (this.object[this.tabProp.key] == null) {
      this.object[this.tabProp.key] = {
        id: null,
        type: null,
        name: null,
        value: null
      }
    }
  },
  methods: {
    validate: function () {
      return this.$refs.field.validate()
    }
  }
}
